import React from 'react'
import classnames from 'classnames/bind'
import css from './styles.module.scss'
import Link from '../Link/index.js'

const cx = classnames.bind(css)

const TagLink = ({ className, href, name }) => {
  return (
    <Link href={href} className={cx(css.TagLink, className)}>
      {name}
    </Link>
  )
}

export default TagLink
